import React from 'react';

export function Card({ children, className = '' }) {
	return (
		<div className={`app-panel transition-shadow duration-200 hover:shadow-md ${className}`}>
			{children}
		</div>
	);
}

export function CardHeader({ children, className = '' }) {
	return (
		<div className={`px-3 py-2 border-b border-slate-200/80 dark:border-slate-700/80 bg-slate-50/80 dark:bg-slate-800/50 rounded-t-xl ${className}`}>{children}</div>
	);
}

export function CardContent({ children, className = '' }) {
	return <div className={`px-3 py-3 ${className}`}>{children}</div>;
}

export function CardFooter({ children, className = '' }) {
	return (
		<div className={`px-4 py-3 border-t border-slate-200/80 dark:border-slate-700/80 bg-slate-50/50 dark:bg-slate-800/40 rounded-b-xl ${className}`}>{children}</div>
	);
}


